module.exports = __webpack_public_path__ + "img/learn.d722c09.svg";